import { render, staticRenderFns } from "./VipPaymentEdit.vue?vue&type=template&id=f2b957ba"
import script from "./VipPaymentEdit.vue?vue&type=script&lang=js"
export * from "./VipPaymentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports